import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];
  static values = {
    resetUrl: String,
    newRecord: Boolean
  }

  search(event) {
    event.preventDefault();

    const input = this.inputTarget;
    const paramValue = input.value;
    const form = event.target.closest("form");

    if (paramValue && form) {
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="search" value="true">');
      form.requestSubmit();
    }
  }

  resetForm(event) {
    const form = this.element.closest("form");
    if (form) {
      const emailValue = this.inputTarget.value;

      if (!this.newRecordValue) {
        form.action = this.resetUrlValue;
        this.newRecordValue = true;

        form.querySelectorAll("input, select, textarea").forEach((field) => {
          if (field !== this.inputTarget && field.type !== "button" && field.type !== "submit") {
            if (field.type === "checkbox" || field.type === "radio") {
              field.checked = false;
            } else {
              field.value = "";
            }
          }
          field.removeAttribute("disabled");
        });
      }

      this.inputTarget.value = emailValue;
    }
  }
}
